import React from "react";
import { Link } from 'react-router-dom';
import rootDir from "../..";

interface Props {
    arrData: any;
}

const CreatorArrTable = ({arrData}: Props) => {
    console.log('arrData => ',arrData)
    return(
        <table id="arrangement-table" border={0} width={'98%'}>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Type</th>
                    <th>Artist</th>
                    <th>Title</th>
                    <th>Album</th>
                    <th>Length</th>
                    {/* <th>Plays</th> */}
                    <th>Genre</th>
                </tr>
            </thead>
            <tbody>
                { arrData ? Object.keys(arrData).map((i,j) => (
                    <tr>
                        <td><img src={rootDir+"img/arr/"+arrData[i].type+".png"} alt={arrData[i].type} height={20}/></td>
                        <td>{arrData[i].type.replace('_', ' ')}</td>
                        <td>{arrData[i].inhouse_cover ? <span className="inhouseCover" title="Made Famous By">(MFB) </span> : null}<Link to={rootDir+'artist/'+arrData[i].artist_id}>{arrData[i].artist_name}</Link></td>
                        <td><Link to={rootDir+'song/'+arrData[i].song_id}>{arrData[i].title}</Link></td>
                        <td><Link to={rootDir+'album/'+arrData[i].album_id}>{arrData[i].album_title}</Link></td>
                        <td>{arrData[i].time}</td>
                        {/* <td className="arrPlays">{arrData[i].plays ? arrData[i].plays : 0}</td> */}
                        <td className="genre">{ Object.keys(arrData[i].genre).map((m,n) => (<button title={arrData[i].genre[n]}>{arrData[i].genre[n]}</button>)) }</td>
                    </tr>
                )) : null

                }
            </tbody>
        </table>
    )
}

export default CreatorArrTable;